import { FeatureFlag } from '../../constants/featureFlags';
import { ACTIVE_FEATURE_FLAGS } from '../featureFlags';
import { useClientHasRendered } from '../hooks';
import { localStorageWrapper } from '../localStorage/localStorageWrapper';

type IResult = Partial<Record<FeatureFlag, boolean>>;

/**
 * Accepts an array of flags and returns an object with those same flags as the key and a boolean
 * as the value indicating if that flag is on or not.
 * Only works client side.
 *
 * @param {string[]} flags
 * @returns {{ [flag: string]: boolean }}
 */
export function useFeatureFlags(flags: FeatureFlag[]): IResult {
  const clientHasRendered = useClientHasRendered();
  if (!clientHasRendered) {
    return {};
  }
  const storedFlags = localStorageWrapper.getItem(ACTIVE_FEATURE_FLAGS);
  const flagSearch = storedFlags as FeatureFlag[];
  const result: IResult = {};
  flags.forEach(flag => {
    const hasFlag = Array.isArray(flagSearch) && flagSearch.includes(flag);

    result[flag] = hasFlag;
  });
  return result;
}
